import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd-css-utilities/utility.min.css';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider as AntdProvider } from 'antd';
import locale from 'antd/lib/locale/ko_KR';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <Router>
    <AntdProvider locale={locale}>
      <App />
    </AntdProvider>
  </Router>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
